export const globalAlertActions = {
  set: 'globalAlert/set',
  remove: 'globalAlert/remove',
};

export const setGlobalAlert = (message: string) => ({
  type: globalAlertActions.set,
  message,
});
export const removeGlobalAlert = () => ({ type: globalAlertActions.remove });
